<style lang="less" scoped>
  .main {
    padding-top: 45px;
    padding-bottom: 50px;
  }
  .nav {
    background-color: #000;
    height: 45px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    color: #fff;
    position: relative;
    text-align: center;
    line-height: 45px;
    font-size: 14px;
    position: fixed;
    width: 100%;
    top: 0;
    .ivu-icon {
      margin-top: 12px;
      margin-left: 10px;
      float: left;
    }
  }
  .order-bar {
    background: #fff;
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100%;
    border-top: 1px solid #eee;
    .bar-left {
      float: left;
      position: relative;
      text-align: left;
      line-height: 50px;
      font-size: 18px;
      color: #ff6615;
      font-weight: 700;
      padding-left: 15px;
    }
    .bar-right {
      line-height: 50px;
      text-align: center;
      background-color: #ff6615;
      color: #fff;
      width: 200px;
      position: absolute;
      right: 0;
    }
  }
  .diy-box {
    width: 100%;
    margin: auto;
    margin-top: 15px;
    position: relative;
    .step_name {
      font-size: 20px;
      color: #ff6615;
      font-weight: 700;
      margin-bottom: 15px;
      padding-left: 15px;
    }
    .parameter_li {
      border-bottom: 1px solid #eee;
      background: #fff;
      padding: 15px;
    }
    .parameter_name {
      font-size: 16px;
      color: #333;
      font-weight: 700;
      margin-bottom: 20px;
    }
    .parameter_box {
      margin-bottom: 15px;
      overflow: hidden;
      overflow-x: auto;
      .item {
        float: left;
        width: 200px;
        margin-right: 15px;
        .item_img {
          width: 200px;
          height: 200px;
          background: #eee;
        }
        .item_name {
          padding-top: 10px;
          padding-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
  .s-title {
    padding: 15px;
  }
  .sh-box {
    overflow: hidden;
    background: #fff;
    padding: 15px;
  }
  .adviser-box {
    overflow: hidden;
    background: #fff;
    padding: 15px;
    .portrait {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      float: left;
    }
    .adviser-right {
      margin-left: 60px;
      .full_name {
        font-size: 18px;
        margin-bottom: 2px;
      }
    }
  }
  .product-li {
    background: #fff;
    border-bottom: 1px solid #eee;
    padding-left: 15px;
    padding-right: 15px;
    height: 45px;
    line-height: 45px;
    span {
      float: right;
    }
  }
  .pay-box{
    background-color: #fff;
    display: block;
    width: 90%;
    padding-top: 30px;
  padding-bottom: 30px;
  margin: auto;
  text-align: center;
  margin-top: 10%;
  }
</style>

<template>
  <div class="main">
    <div class="nav">
      <Icon size="24" @click="$router.go(-1)" color="#fff" type="ios-arrow-back" />
      <span>为本定制</span>
    </div>
    <div class="pay-box">
    
    <img src="assets/images/pay.png" alt="" srcset="">
       <div>
            <Button type="primary" @click="$router.push({ path: '/'})">支付完成</Button>
       </div>
    </div>
  
  </div>
</template>

<script>
  var that;
  import Store from 'store';
  import {
    POST
  } from "../plugins/core";
  export default {
    name: 'order',
    data() {
      return {
        load: true,
        rdata: {
          min_number: 1,
          number: 1
        }
      }
    },
    mounted() {
      that = this;
    },
    methods: {
      init() {
        var order_code = that.$route.params.id;
        POST('/getPlaceOrder', {
          order_code
        }).then(function(res) {
          that.load = false;
          that.rdata = res.data;
        });
      },
      placeOrder() {
        var product_id = that.$route.params.id;
        var enterprise_id = Store.get("enterprise_id");
        var diy_data = JSON.stringify(that.rdata);;
        that.load = true;
        POST('/getAdviserPlaceOrder', {
          product_id,
          enterprise_id,
          diy_data
        }).then(function(res) {
          that.load = false;
          if (res.state == 200) {
            that.$router.push({
              path: '/order/' + res.data.order_code
            })
          } else {
            that.$Message.error(res.msg);
          }
        });
      }
    }
  }
</script>
